import { Col, message, Row } from "antd";
import { StatusList } from "./statusList/statusList";
import { usePageFilter } from "../../../../../hooks/usePageFilters";
import ClientWorkflow from "../../../../../redux/models/clientWorkflow";
import { SubStatusDetails } from "./subStatusDetails/subStatusDetails";
import { getCandidateStatusKey } from "../../../../../utilities/candidate";
import { useVisibleTransitions } from "../hooks/useVisibleTransitions";

export const WorkflowStatuses = ({
  statuses,
  statusesById,
  subStatusesById,
  transitions,
  clientId,
  onPositionUpdate,
  onWorkflowUpdated,
}) => {
  const initialSubStatus = statuses[0].subStatuses[0];

  const [selectedSubStatusId, setSelectedSubStatusId] = usePageFilter(
    "candidate_workflow_statuses_selected_status",
    getCandidateStatusKey(initialSubStatus.statusId, initialSubStatus.id),
  );

  const selectedSubStatus = subStatusesById[selectedSubStatusId];
  const selectedStatus = statusesById[selectedSubStatus?.statusId];

  const [expandedStatusIds, setExpandedStatusIds] = usePageFilter(
    "candidate_workflow_expanded_ids",
    [statuses[0].id],
  );

  const visibleTransitions = useVisibleTransitions(transitions);

  const onSubStatusSelected = (ss) => {
    setSelectedSubStatusId(getCandidateStatusKey(ss.statusId, ss.id));
  };

  const toggleExpandedStatus = (statusId) => {
    if (expandedStatusIds.includes(statusId)) {
      return setExpandedStatusIds(
        expandedStatusIds.filter((s) => s !== statusId),
      );
    }

    return setExpandedStatusIds([...expandedStatusIds, statusId]);
  };

  const handleSubStatusToggle = async (checked) => {
    try {
      const { data } = await ClientWorkflow.updateSubStatus(
        clientId,
        selectedSubStatus.id,
        {
          isActive: checked,
        },
      );

      const { transitions, ...workflowData } = data;

      message.success("Sub-status updated successfully");
      onWorkflowUpdated(workflowData, transitions);
    } catch (error) {
      message.error("Failed to update sub-status");
      console.error(error);
    }
  };

  const handleTransitionToggle = async (transitionId, checked, isCustom) => {
    try {
      const { data } = await (isCustom
        ? ClientWorkflow.updateCustomTransition(clientId, transitionId, {
            isActive: checked,
          })
        : ClientWorkflow.updateTransition(clientId, transitionId, {
            isActive: checked,
          }));

      const { transitions, ...workflowData } = data;

      message.success("Transition updated successfully");
      onWorkflowUpdated(workflowData, transitions);
    } catch (error) {
      message.error("Failed to update transition");
      console.error(error);
    }
  };

  return (
    <Row gutter={[16, 16]} wrap={false}>
      <Col flex="0 0 340px">
        <StatusList
          data={statuses}
          onSubStatusSelected={onSubStatusSelected}
          selectedSubStatus={selectedSubStatus}
          expandedStatusIds={expandedStatusIds}
          onStatusExpanded={toggleExpandedStatus}
          onPositionUpdate={onPositionUpdate}
        />
      </Col>
      <Col flex={1}>
        <SubStatusDetails
          statusesById={statusesById}
          subStatusesById={subStatusesById}
          selectedStatus={selectedStatus}
          selectedSubStatus={selectedSubStatus}
          transitions={visibleTransitions}
          onSubStatusToggle={handleSubStatusToggle}
          onTransitionToggle={handleTransitionToggle}
        />
      </Col>
    </Row>
  );
};
